import { render, staticRenderFns } from "./VendorDetails.vue?vue&type=template&id=7f36edff&"
import script from "./VendorDetails.vue?vue&type=script&lang=js&"
export * from "./VendorDetails.vue?vue&type=script&lang=js&"
import style0 from "./VendorDetails.vue?vue&type=style&index=0&id=7f36edff&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports